import Vue from 'vue';
import store from '../store';
import injector from 'vue-inject';
Vue.use(injector);

require('./api');
require('./status');

let api         = injector.get('api'),
    countries   = injector.get('countries'),
    status      = injector.get('status');

class User {
    fetchData(userData) {
        return new Promise((resolve) => {
            store.commit('setUser', userData);
            store.commit('setSettings', userData);
            store.commit('loginUser');
            countries.fetchList();
            this.isBanned();
            resolve();
        });
    }

    isBanned() {
        return new Promise(resolve => {
            Vue.http.get(api.auth.location.banned).then(response => {
                if (response.data && response.data.data) {
                    return resolve({
                        banned: response.data.data.banned,
                        location: response.data.data.location
                    });
                }
                return resolve(null);
            }, error => {
                status['status' + error.status]();
                return resolve(null);
            });
        });
    }

    reloadData () {
        return new Promise((resolve, reject) => {
            Vue.http.get(api.auth.user).then(response => {
                this.fetchData(response.data).then(() => {
                    resolve();
                });
            }, error => {
                status['status' + error.status]();
                reject();
            });
        });
    }
}

injector.service('user', User);



// WEBPACK FOOTER //
// ./src/services/user.js